import dynamic from 'next/dynamic'

export const DynamicCouponsFilterModal = dynamic(
  () => import('.').then((mod) => mod.CouponsFilterModal),
  { ssr: false },
)
